function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { Waypoint } from 'react-waypoint';
import ArrowKeyListener from '../utils/ArrowKeyListener';

var TableBody = /*#__PURE__*/function (_PureComponent) {
  _inherits(TableBody, _PureComponent);

  var _super = _createSuper(TableBody);

  function TableBody() {
    var _this;

    _classCallCheck(this, TableBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleLoadData", function (_ref) {
      var event = _ref.event;
      var onLoadData = _this.props.onLoadData;
      return onLoadData(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoadDataUp", function (_ref2) {
      var event = _ref2.event;
      var onLoadDataUp = _this.props.onLoadDataUp;
      return onLoadDataUp(event);
    });

    return _this;
  }

  _createClass(TableBody, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          height = _this$props.height,
          minWidth = _this$props.minWidth,
          showWaypoint = _this$props.showWaypoint,
          showWaypointUp = _this$props.showWaypointUp,
          tableBodyRef = _this$props.tableBodyRef,
          rtTbodyRef = _this$props.rtTbodyRef,
          verticalScroll = _this$props.verticalScroll,
          onKeyListener = _this$props.onKeyListener;
      var tableClass = classnames({
        'rt-tbody': true,
        'rt-fit-content': true,
        'table__body--fixed': !verticalScroll
      });
      return /*#__PURE__*/React.createElement("div", {
        className: tableClass,
        role: "presentation",
        style: {
          height: height,
          minWidth: minWidth
        },
        ref: rtTbodyRef
      }, /*#__PURE__*/React.createElement(ArrowKeyListener, {
        onUp: function onUp(e) {
          e.preventDefault();
          onKeyListener(e.key);
        },
        onDown: function onDown(e) {
          e.preventDefault();
          onKeyListener(e.key);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "width-100p position-relative display-block",
        ref: tableBodyRef,
        role: "rowgroup"
      }, showWaypointUp && /*#__PURE__*/React.createElement(Waypoint, {
        onEnter: this.handleLoadDataUp
      }), children, showWaypoint && /*#__PURE__*/React.createElement(Waypoint, {
        onEnter: this.handleLoadData
      }))));
    }
  }]);

  return TableBody;
}(PureComponent);

_defineProperty(TableBody, "propTypes", {
  children: PropTypes.node,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minWidth: PropTypes.string,
  onLoadData: PropTypes.func,
  onLoadDataUp: PropTypes.func,
  showWaypoint: PropTypes.bool,
  showWaypointUp: PropTypes.bool,
  tableBodyRef: PropTypes.any,
  rtTbodyRef: PropTypes.any,
  verticalScroll: PropTypes.bool,
  onKeyListener: PropTypes.func
});

TableBody.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleLoadData",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ event }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleLoadDataUp",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ event }",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "TableBody",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "height": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": ""
    },
    "minWidth": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onLoadData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onLoadDataUp": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "showWaypoint": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "showWaypointUp": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "tableBodyRef": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "rtTbodyRef": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "verticalScroll": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onKeyListener": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
export default TableBody;